<template>
  <div class="history_home">
    <div class="nav_con">
      <span @click="$router.push('/')" class="home_tab">首页</span>
      <
      <span @click="$router.push('/pcpage_history/history_home')" style="cursor: pointer">往期回顾</span>
      <span>-{{yearList[$route.query.year].value}}</span>
    </div>
    <time-nav @changeYear="changeYear"></time-nav>
    
    <div class="work_wrap">
      <ul class="work_nav clearfix">
        <li @click="changeNav(0)" :class="{'active': navKey == 0}">
          短视频
          <span class="en_nav">VLOG</span>
        </li>
        <li @click="changeNav(1)" :class="{'active': navKey == 1}">
          图组
          <span class="en_nav">PLOG</span>
        </li>
        <li @click="changeNav(2)" :class="{'active': navKey == 2}">
          单图
          <span class="en_nav">PLOG</span>
        </li>
      </ul>
      <ul class="work_list clearfix">
        <li v-for="(v, i) in workList" :key="i" @click="goDetail(v)">
          <img src="../../img/play_btn.png" alt="" class="play_btn" v-if="navKey == 0">
          <img :src="navKey == 0 ? 'https://collection2021-cos.chineseplus.net/'+v.video_cover : 'https://collection2021-cos.chineseplus.net/'+v.cover" alt="" class="cover">
        </li>
      </ul>

      <div class="more" v-if="showMore" @click="getMore()">更多     MORE</div>
    </div>
  </div>
</template>

<script>
import timeNav from './common/timeNav'

export default {
  components: {
    timeNav
  },
  data () {
    return {
      type: 1,
      yearList: [
        {
          value: '2015'
        },
        {
          value: '2016'
        },
        {
          value: '2017'
        },
        {
          value: '2018'
        },
        {
          value: '现在'
        }
      ],
      yearIndex: 0,
      navKey: 0,
      workList: [],
      page: 1,
      pageSize: 12,
      total: 0,
      showMore: true
    }
  },
  created () {
    this.navKey = this.$route.query.type - 1
    this.changeNav(this.navKey)
  },
  methods: {
    changeYear (yearIndex) {
      this.yearIndex = yearIndex
      this.$router.push({
        path: this.$route.path,
        query: {
          year: yearIndex,
          type: this.navKey + 1
        }
      })
      this.page = 1
      this.workList = []
      this.workList.length = 0
      this.getList(this.navKey)
    },
    changeNav (key) {
      this.navKey = key
      this.page = 1
      this.workList = []
      this.workList.length = 0
      this.getList(key)
    },
    // 获取列表
    getList () {
      this.$utils.get('/works/list-history', {
        year: this.yearList[this.$route.query.year].value.substr(0, 4),
        type: this.navKey + 1,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if(res.code == 1000) {
          this.showMore = true
          if (!res.data.list.length) {
            this.showMore = false
          }
          this.workList.push(...res.data.list)
          this.total = res.data.total
          this.workList = this.workList.filter(v => {
            return v.type == this.navKey + 1
          })
          if (this.workList.length == res.data.total) {
            this.showMore = false
          }
        }
      })
    },
    // 去详情
    goDetail (item) {
      let path = ''
      if (item.type == 1) {
        path = '/pcpage_history/vlogdetail'
      } else {
        path = '/pcpage_history/plogdetail'
      }
      this.$router.push({
        path,
        query: {
          id: item.works_id
        }
      })
    },
    getMore () {
      this.page++
      this.getList()
    }
  },
}
</script>

<style scoped lang="scss">
.history_home {
  width: 1200px;
  height: 100%;
  margin: auto;
  font-size: 24px;
  .nav_con {
    color: #fff;
    font-size: 25px;
    margin-top: 30px;
    .home_tab {
      cursor: pointer;
    }
  }
  .work_wrap {
    width: 1200px;
    background: rgba(255, 255, 255, .8);
    padding: 40px;
    box-sizing: border-box;
    margin-top: 40px;
    .work_nav {
      color: #fff;
      padding-left: 35px;
      margin-top: -70px;
      li {
        width: 301px;
        height: 61px;
        background-image: linear-gradient(0deg, 
          #aba7e2 0%, 
          #dbd9f6 100%);
        border-radius: 29px;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        line-height: 60px;
        float: left;
        margin-right: 74px;
        cursor: pointer;
        &.active {
          background-image: linear-gradient(0deg, 
        #746bef 0%, 
        #728bf9 100%);
        }
        &:last-child {
          margin-right: 0;
        }
        .en_nav {
          color: rgba(255, 255, 255, .8);
          font-size: 26px;
          font-weight: bold;
        }
      }

    }
    .work_list {
      margin-top: 43px;
      li {
        float: left;
        margin-right: 20px;
        margin-bottom: 20px;
        width: 360px;
	      height: 226px;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .cover {
          display: block;
          width: 100%;
          min-height: 100%;
        }
        .play_btn {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: 44px;
          height: 44px;

        }
      }
    }
    .more {
      width: 100%;
      height: 63px;
	    background-color: #9576ef;
      font-size: 25px;
      color: #fff;
      line-height: 62px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
